import PropTypes from 'prop-types';
import { Icon } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import { Assignment, BookOpen, MoneyOutline } from '@openedx/paragon/icons';
import messages from './CatalogCourseModalBanner.messages';
import { checkSubscriptions } from '../../utils/catalogUtils';

const CatalogProgramModalBanner = ({
  coursePrice,
  courseAssociatedCatalogs,
  courses,
}) => {
  const intl = useIntl();

  return (
    <div className="banner">
      {coursePrice !== undefined && (
      <>
        <div className="banner-section mx-3">
          <div className="banner h4 mb-0">
            <Icon className="mr-1" src={MoneyOutline} />
            {coursePrice}
          </div>
          <div className="banner-subtitle small">
            {intl.formatMessage(
              messages['CatalogCourseModalBanner.bannerPriceTextProgram'],
            )}
          </div>
        </div>
        <div className="banner-section slash">/</div>
      </>
      )}
      {courses && courses.length > 0 && (
      <>
        <div className="banner-section mx-3">
          <div className="banner h4 mb-0">
            <Icon className="mr-1" src={Assignment} />
            {courses.length} courses
          </div>
          <div className="banner-subtitle small">
            {intl.formatMessage(
              messages['CatalogCourseModalBanner.bannerCourseText'],
            )}
          </div>
        </div>
        <div className="banner-section slash">/</div>
      </>
      )}
      {checkSubscriptions(courseAssociatedCatalogs) && (
      <div className="banner-section mx-3">
        <div className="banner h4 mb-0">
          <Icon className="mr-1" src={BookOpen} />
          {intl.formatMessage(
            messages['CatalogCourseModalBanner.bannerCatalogText'],
          )}
        </div>
        <div className="banner-subtitle small">
          {checkSubscriptions(courseAssociatedCatalogs)}
        </div>
      </div>
      )}
    </div>
  );
};

CatalogProgramModalBanner.defaultProps = {
  coursePrice: '$0',
  courseAssociatedCatalogs: [],
  courses: [],
};

CatalogProgramModalBanner.propTypes = {
  coursePrice: PropTypes.string,
  courseAssociatedCatalogs: PropTypes.arrayOf(PropTypes.string),
  courses: PropTypes.arrayOf(PropTypes.shape({})),
};

export default CatalogProgramModalBanner;
